import { render, staticRenderFns } from "./PreviewFileDialog.vue?vue&type=template&id=b6f8874e&scoped=true&"
import script from "./PreviewFileDialog.vue?vue&type=script&lang=ts&"
export * from "./PreviewFileDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f8874e",
  null
  
)

export default component.exports